(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hw-dimensions-diagrams"] && !Shopify.designMode) return;
  try {
    (() => {
    const namespace = 'hw__dimensions_diagrams__dialog';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let dialog;
    let image;
    let currentHref;

    const finishClose = () => {
      if (dialog.classList.contains(`${namespace}--closing`)) dialog.close();
    };

    const requestClose = () => {
      if (reducedMotion.matches || dialog.classList.contains(`${namespace}--closing`)) {
        dialog.close();
        return;
      }

      dialog.classList.remove(`${namespace}--zoomed`);
      dialog.classList.add(`${namespace}--closing`);

      // Fallback for when the closing animation never ends
      setTimeout(finishClose, 400);
    };

    const build = () => {
      dialog = document.createElement('dialog');
      dialog.className = namespace;

      const close = document.createElement('button');
      close.type = 'button';
      close.className = `${namespace}_close`;
      close.setAttribute('aria-label', 'Close');
      close.textContent = '×';
      close.addEventListener('click', requestClose);

      image = document.createElement('img');
      image.className = `${namespace}_image`;
      image.addEventListener('animationend', finishClose);
      image.addEventListener('click', () => {
        if (dialog.classList.contains(`${namespace}--zoomable`)) {
          dialog.classList.toggle(`${namespace}--zoomed`);
        }
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) requestClose();
      });
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        requestClose();
      });
      dialog.addEventListener('close', () => {
        dialog.classList.remove(`${namespace}--zoomed`, `${namespace}--closing`);
      });

      dialog.append(close, image);
      document.body.append(dialog);
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('[data-hw-dimensions-diagrams-zoom]');

      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !window.HTMLDialogElement) return;

      const thumbnail = link.querySelector('img');

      if (!thumbnail) return;

      event.preventDefault();

      if (!dialog) build();

      const fullWidth = Number(thumbnail.getAttribute('width')) || thumbnail.naturalWidth;
      const fullHeight = Number(thumbnail.getAttribute('height')) || thumbnail.naturalHeight;
      const rect = thumbnail.getBoundingClientRect();
      const fittedWidth = Math.min(window.innerWidth, (window.innerHeight * fullWidth) / fullHeight, fullWidth);

      dialog.style.setProperty('--hw-dd-from-x', `${rect.left + rect.width / 2 - window.innerWidth / 2}px`);
      dialog.style.setProperty('--hw-dd-from-y', `${rect.top + rect.height / 2 - window.innerHeight / 2}px`);
      dialog.style.setProperty('--hw-dd-from-scale', rect.width / fittedWidth);
      dialog.classList.remove(`${namespace}--zoomed`, `${namespace}--closing`);
      dialog.classList.toggle(`${namespace}--zoomable`, fullWidth > window.innerWidth || fullHeight > window.innerHeight);

      // Shows the already loaded image at full dimensions until the full size file is ready
      const href = link.href;
      currentHref = href;
      image.alt = thumbnail.alt;
      dialog.setAttribute('aria-label', thumbnail.alt || 'Image');
      image.width = fullWidth;
      image.height = fullHeight;
      image.src = thumbnail.currentSrc || href;

      const full = new Image();
      full.src = href;
      full.decode().then(() => {
        if (dialog.open && currentHref === href) image.src = href;
      }, () => {});

      dialog.showModal();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hw-product-variations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hw-product-variations')) {
    const HW_PV_GAP = 8;
    const HW_PV_OFFSET = 12;
    const HW_PV_CARET_INSET = 16;
    const HW_PV_HIDE_DELAY = 100;
    const hwPvSupportsPopover = Object.prototype.hasOwnProperty.call(HTMLElement.prototype, 'popover');

    class HwProductVariations extends HTMLElement {
      connectedCallback() {
        this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.abortController = new AbortController();
        this.activeItem = null;
        this.hideTimer = null;

        const { signal } = this.abortController;

        const items = [...this.querySelectorAll('.hw__pv__item')].filter((item) => this.getPopover(item));
        if (!items.length) return;

        items.forEach((item) => {
          item.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') this.show(item);
          }, { signal });
          item.addEventListener('pointerleave', (event) => {
            if (event.pointerType === 'mouse') this.scheduleHide();
          }, { signal });
          item.addEventListener('focusin', (event) => {
            if (event.target.matches(':focus-visible')) this.show(item);
          }, { signal });
          item.addEventListener('focusout', () => this.hide(), { signal });
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.hide();
        }, { signal });
        window.addEventListener('scroll', () => this.hide(), { signal, passive: true });
        window.addEventListener('resize', () => this.hide(), { signal, passive: true });
      }

      disconnectedCallback() {
        this.abortController.abort();
        this.hide();
      }

      getPopover(item) {
        return item ? item.querySelector(':scope > .hw__pv__popover') : null;
      }

      show(item) {
        if (!this.hoverQuery.matches) return;

        clearTimeout(this.hideTimer);

        if (this.activeItem === item) return;

        this.hide();

        const popover = this.getPopover(item);
        if (!popover) return;

        if (hwPvSupportsPopover) {
          popover.showPopover();
        } else {
          popover.classList.add('hw__pv__popover--open');
        }

        this.activeItem = item;
        this.position(item, popover);

        const image = popover.querySelector('img');
        if (image && !image.complete) {
          image.addEventListener('load', () => {
            if (this.activeItem === item) this.position(item, popover);
          }, { once: true });
        }
      }

      scheduleHide() {
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => this.hide(), HW_PV_HIDE_DELAY);
      }

      hide() {
        clearTimeout(this.hideTimer);

        const popover = this.getPopover(this.activeItem);
        this.activeItem = null;

        if (!popover) return;

        if (hwPvSupportsPopover) {
          if (popover.matches(':popover-open')) popover.hidePopover();
        } else {
          popover.classList.remove('hw__pv__popover--open');
        }
      }

      position(item, popover) {
        const trigger = item.firstElementChild || item;
        const triggerRect = trigger.getBoundingClientRect();
        const popoverRect = popover.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = document.documentElement.clientHeight;

        let placement = 'top';
        let top = triggerRect.top - popoverRect.height - HW_PV_OFFSET;

        if (top < HW_PV_GAP) {
          placement = 'bottom';
          top = triggerRect.bottom + HW_PV_OFFSET;

          if (top + popoverRect.height > viewportHeight - HW_PV_GAP) {
            placement = '';
            top = Math.max(HW_PV_GAP, viewportHeight - popoverRect.height - HW_PV_GAP);
          }
        }

        let left = triggerRect.left + (triggerRect.width - popoverRect.width) / 2;
        left = Math.max(HW_PV_GAP, Math.min(left, viewportWidth - popoverRect.width - HW_PV_GAP));

        const caretX = triggerRect.left + triggerRect.width / 2 - left;
        const caretMin = HW_PV_CARET_INSET;
        const caretMax = popoverRect.width - HW_PV_CARET_INSET;

        popover.style.top = `${Math.round(top)}px`;
        popover.style.left = `${Math.round(left)}px`;
        popover.style.setProperty('--hw-pv-caret-x', `${Math.round(Math.min(Math.max(caretX, caretMin), caretMax))}px`);

        if (placement) {
          popover.dataset.placement = placement;
        } else {
          delete popover.dataset.placement;
        }
      }
    }

    customElements.define('hw-product-variations', HwProductVariations);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hw-shipping-estimate-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const modal = document.getElementById('hw__se_modal');
    if (!modal || modal.dataset.hwSeInit) return;
    modal.dataset.hwSeInit = 'true';

    const ANCHOR = modal.dataset.anchor || 'hw-shipping-estimates';
    // Locale-aware base for AJAX API calls; always ends in "/".
    const ROOT = window.Shopify?.routes?.root || '/';
    const MAX_POLL_ATTEMPTS = 20;
    const POLL_INTERVAL_MS = 500;
    const SAMPLE_PROPERTY = '_hw_shipping_estimate';

    const form = modal.querySelector('[data-hw-se-form]');
    const results = modal.querySelector('[data-hw-se-results]');
    const submit = modal.querySelector('[data-hw-se-submit]');
    const spinner = modal.querySelector('.hw__se-spinner');
    const countrySelect = modal.querySelector('[data-hw-se-country]');
    const provinceField = modal.querySelector('[data-hw-se-province-field]');
    const provinceSelect = modal.querySelector('[data-hw-se-province]');
    const zipInput = modal.querySelector('[data-hw-se-zip]');

    const {
      country: defaultCountry = '',
      sampleVariant = '',
      currency = '',
      locale = 'en',
      errorText = '',
      noRatesText = '',
      noSampleText = '',
      resultsHeading = '',
      freeText = 'Free'
    } = modal.dataset;
    const showDescription = modal.hasAttribute('data-show-description');

    let lastFocused = null;
    let cleanFrame = null;

    const formatMoney = (value) => {
      const amount = parseFloat(value);
      if (Number.isNaN(amount)) return value;
      if (amount === 0) return freeText;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
      } catch (e) {
        return amount.toFixed(2);
      }
    };

    const openModal = () => {
      if (modal.open) return;
      lastFocused = document.activeElement;
      modal.showModal();
      document.documentElement.style.overflow = 'hidden';
      (countrySelect || zipInput)?.focus();
    };

    const onClosed = () => {
      document.documentElement.style.overflow = '';
      if (location.hash === '#' + ANCHOR) {
        history.replaceState(null, '', location.pathname + location.search);
      }
      lastFocused?.focus?.();
    };

    const setLoading = (isLoading) => {
      submit.disabled = isLoading;
      submit.setAttribute('aria-busy', isLoading);
      spinner.hidden = !isLoading;
    };

    const renderMessage = (text, isError) => {
      const p = document.createElement('p');
      p.className = 'hw__se-results__message' + (isError ? ' hw__se-results__message--error' : '');
      p.textContent = text;
      results.replaceChildren(p);
    };

    const renderRates = (rates) => {
      if (!rates?.length) {
        renderMessage(noRatesText, false);
        return;
      }

      const heading = document.createElement('p');
      heading.className = 'hw__se-results__message';
      heading.textContent = resultsHeading;

      const list = document.createElement('ul');
      list.className = 'hw__se-rates';
      rates.forEach((rate) => {
        const item = document.createElement('li');
        item.className = 'hw__se-rates__item';

        const name = document.createElement('span');
        name.className = 'hw__se-rates__name';

        const title = document.createElement('span');
        title.className = 'hw__se-rates__title';
        title.textContent = rate.presentment_name || rate.name;
        name.append(title);

        if (showDescription && rate.description) {
          const description = document.createElement('span');
          description.className = 'hw__se-rates__description';
          description.textContent = rate.description;
          name.append(description);
        }

        const price = document.createElement('span');
        price.className = 'hw__se-rates__price';
        price.textContent = formatMoney(rate.price);

        item.append(name, price);
        list.append(item);
      });

      results.replaceChildren(...(resultsHeading ? [heading, list] : [list]));
    };

    const buildAddressQuery = (address) => Object.entries(address)
      .filter(([, value]) => value)
      .map(([key, value]) => `shipping_address[${key}]=${encodeURIComponent(value)}`)
      .join('&');

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const fetchJson = async (cleanFetch, url, options = {}) => {
      const response = await cleanFetch(ROOT + url, {
        ...options,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
      });
      if (!response.ok) throw new Error(url);
      return response.json();
    };

    const fetchRates = async (cleanFetch, query) => {
      await fetchJson(cleanFetch, `cart/prepare_shipping_rates.json?${query}`, { method: 'POST' });
      for (let attempt = 0; attempt <= MAX_POLL_ATTEMPTS; attempt++) {
        const data = await fetchJson(cleanFetch, `cart/async_shipping_rates.json?${query}`);
        if (data?.shipping_rates !== undefined) return data.shipping_rates;
        await delay(POLL_INTERVAL_MS);
      }
      throw new Error('timeout');
    };

    /*
     * Cart drawers, Klaviyo, Rebuy and Shopify Web Pixels patch window.fetch to spot cart/add.js and emit
     * add_to_cart events. The sample line is synthetic, so it must not be observed. fetch patches are per-realm,
     * so a same-origin about:blank iframe provides an untouched copy. Don't switch these calls back to
     * window.fetch, and don't reuse this fetch for genuine cart interactions.
     */
    const getCleanFetch = () => {
      destroyCleanFrame();
      const frame = document.createElement('iframe');
      frame.src = 'about:blank';
      frame.hidden = true;
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      document.body.append(frame);

      const frameWindow = frame.contentWindow;
      if (typeof frameWindow?.fetch !== 'function') {
        frame.remove();
        // No fallback to window.fetch: a phantom add_to_cart event is worse than no estimate.
        return null;
      }

      cleanFrame = frame;
      return frameWindow.fetch.bind(frameWindow);
    };

    const destroyCleanFrame = () => {
      cleanFrame?.remove();
      cleanFrame = null;
    };

    const addSampleItem = async (cleanFetch) => {
      try {
        const item = await fetchJson(cleanFetch, 'cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ id: sampleVariant, quantity: 1, properties: { [SAMPLE_PROPERTY]: '1' } })
        });
        if (item?.key) return item.key;
      } catch (e) {
        // Falls through to the sample error below, e.g. the sample sold out since the page was rendered.
      }
      throw new Error('sample_unavailable');
    };

    const removeSampleItem = (cleanFetch, key) => fetchJson(cleanFetch, 'cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: 0 })
    }).catch(() => {});

    const estimateWithSample = async (cleanFetch, query) => {
      const key = await addSampleItem(cleanFetch);
      try {
        return await fetchRates(cleanFetch, query);
      } finally {
        await removeSampleItem(cleanFetch, key);
      }
    };

    const handleSubmit = async (event) => {
      event.preventDefault();

      const address = {
        country: countrySelect ? countrySelect.value : defaultCountry,
        province: provinceSelect && !provinceField.hidden ? provinceSelect.value : '',
        zip: zipInput.value.trim()
      };

      if (!address.zip) {
        zipInput.focus();
        return;
      }

      const cleanFetch = getCleanFetch();
      if (!cleanFetch) {
        renderMessage(errorText, true);
        return;
      }

      setLoading(true);
      results.replaceChildren();

      try {
        // The cart may have changed in a drawer since the page loaded, so check it now.
        const cart = await fetchJson(cleanFetch, 'cart.js');
        const query = buildAddressQuery(address);
        let rates;

        if (cart.item_count > 0) {
          rates = await fetchRates(cleanFetch, query);
        } else if (sampleVariant) {
          rates = await estimateWithSample(cleanFetch, query);
        } else {
          throw new Error('sample_unavailable');
        }

        renderRates(rates);
      } catch (error) {
        renderMessage(error.message === 'sample_unavailable' ? noSampleText : errorText, true);
      } finally {
        destroyCleanFrame();
        setLoading(false);
      }
    };

    const loadProvinces = () => {
      if (!countrySelect || !provinceSelect) return;

      let provinces = [];
      try {
        provinces = JSON.parse(countrySelect.selectedOptions[0]?.dataset.provinces || '[]');
      } catch (e) {
        provinces = [];
      }

      provinceSelect.replaceChildren(...provinces.map(([value, label]) => new Option(label, value)));
      provinceField.hidden = !provinces.length;
    };

    if (countrySelect && defaultCountry) {
      const option = [...countrySelect.options].find((opt) => opt.value === defaultCountry);
      if (option) option.selected = true;
    }

    countrySelect?.addEventListener('change', loadProvinces);
    loadProvinces();

    form.addEventListener('submit', handleSubmit);

    modal.addEventListener('click', (event) => {
      // Clicks on the dialog element itself are backdrop clicks.
      if (event.target === modal || event.target.closest('[data-hw-se-close]')) {
        modal.close();
      }
    });

    // Fired by close() and by native Escape handling.
    modal.addEventListener('close', onClosed);

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.(`a[href="#${ANCHOR}"], a[href$="#${ANCHOR}"]`);
      if (!trigger) return;
      event.preventDefault();
      openModal();
    });

    const checkHash = () => {
      if (location.hash === '#' + ANCHOR) openModal();
    };

    window.addEventListener('hashchange', checkHash);
    checkHash();
  })();
  } catch(e) { console.error(e); }
})();

})();
